import { AlertCircle, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { LOGIN_COLORS } from '../../constants/login-theme';
import SSOSigninCard from '../sso-signin-card/sso-signin-card';

export const Signin = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const ssoError = location.state?.ssoError;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col items-center gap-2 text-center">
        <h2
          className="break-words text-[1.75rem] font-bold leading-tight tracking-tight sm:text-[2rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('WELCOME')}
        </h2>
        <p className="text-base font-normal leading-6" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('CONTINUE_LOGIN_SSO')}
        </p>
      </div>

      {ssoError && (
        <div
          role="alert"
          className="flex items-start gap-2 rounded-lg border border-destructive bg-destructive-subtle p-3"
        >
          <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-destructive-subtle-foreground" />
          <p className="text-sm font-normal text-destructive-subtle-foreground">{ssoError}</p>
        </div>
      )}

      <div className="flex flex-col gap-3">
        <SSOSigninCard />
        <p
          className="flex items-center justify-center gap-1.5 text-center text-xs"
          style={{ color: LOGIN_COLORS.textMuted }}
        >
          <ShieldCheck className="h-3.5 w-3.5 shrink-0" />
          {t('LOGIN_REDIRECT_HINT')}
        </p>
      </div>
    </div>
  );
};
